/**
 *
 * ******************** TODO *****************************
 * Need to standardize on one sortAndFilter mapping.
 * The UI should not be handling complex mapping as below.
 * *******************************************************
 *
 */
export var initializeSortAndFilterObject = function (universalSortAndFilter) {
  var _a;
  var filters = {};
  var keywordPlaceholder = '';
  var keywordValue = '';
  (_a = universalSortAndFilter === null || universalSortAndFilter === void 0 ? void 0 : universalSortAndFilter.filterSections) === null || _a === void 0 ? void 0 : _a.forEach(function (filterSection) {
    var _a;
    filters = (_a = filterSection.fields) === null || _a === void 0 ? void 0 : _a.reduce(function (map, current) {
      var _a;
      if (current.__typename === 'ShoppingTextInputField') {
        map[current.id] = map[current.id] || {};
        current = current;
        keywordPlaceholder = current.placeholder || '';
        keywordValue = current.selected || '';
      } else {
        current = current;
        (_a = current.options) === null || _a === void 0 ? void 0 : _a.forEach(function (option) {
          map[option.id] = map[option.id] || {};
          map[option.id][option.value] = {
            selected: option.selected,
            enabled: !option.disabled
          };
          if (option.nestedOptions && option.nestedOptions.length > 0) {
            option.nestedOptions.forEach(function (nestedOption) {
              map[option.id][nestedOption.value] = {
                selected: nestedOption.selected,
                enabled: !nestedOption.disabled
              };
            });
          }
        });
      }
      return map;
    }, {});
  });
  return {
    filters: filters,
    keywordPlaceholder: keywordPlaceholder,
    keywordValue: keywordValue
  };
};